import React from 'react';

function renderWarning(touched, error) {
  if (!(touched && error)) {
    return;
  }

  if (error === true) {
    return;
  }

  return (
    <div className="alert alert-danger" role="alert">
      {error}
    </div>
  );
}

function renderClass(touched, error) {
  let className = 'form-control form-control-lg';

  if (touched) {
    className += typeof error === 'undefined' ? ' is-valid' : ' is-invalid';
  }

  return className;
}

export default ({ input, label, type, autoFocus, required, meta: { touched, error }, children, rows }) => {
  let fieldElement;
  if (type === 'input' || type === 'password' || type === 'email') {
    fieldElement = (
      <input
        {...input}
        type={type}
        id={input.name}
        placeholder={label}
        className={renderClass(touched, error)}
        autoFocus={autoFocus}
        required={required}
      />
    );
  } else if (type === 'select') {
    fieldElement = (
      <select {...input} id={input.name} className={renderClass(touched, error)} autoFocus={autoFocus} required={required}>
        {children}
      </select>
    );
  } else if (type === 'textarea') {
    fieldElement = (
      <textarea
        {...input}
        id={input.name}
        placeholder={label}
        className={renderClass(touched, error)}
        autoFocus={autoFocus}
        rows={rows}
        required={required}
      />
    );
  }

  return (
    <div className="form-group">
      <label htmlFor="email" className="sr-only">
        {label}
      </label>
      {fieldElement}
      {renderWarning(touched, error)}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/misc/components/FormField.js